import React, { Component } from "react";
import Image from "react-bootstrap/Image";

export class IncrementDecrement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: 0,
      show: true,
      max: 5,
      min: 0,
    };
  }

  IncrementItem = () => {
    this.setState((prevState) => {
      if (prevState.quantity < 100) {
        return {
          quantity: prevState.quantity + 1,
        };
      } else {
        return null;
      }
    });
  };

  DecreaseItem = () => {
    this.setState((prevState) => {
      if (prevState.quantity > 0) {
        return {
          quantity: prevState.quantity - 1,
        };
      } else {
        return null;
      }
    });
  };

  ToggleClick = () => {
    this.setState({
      show: !this.state.show,
    });
  };

  handleChange = (event) => {
    this.setState({ quantity: event.target.value });
  };

  render() {
    return (
      <React.Fragment>
        <div className="reusable-Input-decrement-Component">
          <div className="image-box-section">
            <div className="text-center">
              <Image
                src={this.props.iconImage}
                alt="icon photo"
                title={this.props.title}
              />
              <p className="">{this.props.iconText}</p>
            </div>
          </div>
          <div className="input-box-section">
            <button className="button-custom" onClick={this.props.decreaseItem}>
              <i className="fa fa-minus" aria-hidden="true"></i>
            </button>
            <input
              className="inputne"
              name={this.props.name}
              value={this.props.quantity}
              onChange={this.props.onChange}
              // type={this.props.type}
              disabled={true}
            />
            <button
              className="button-custom"
              onClick={this.props.incrementItem}
            >
              <i className="fa fa-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default IncrementDecrement;
